import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import useContactStore from '../../stores/contactStore'
import useToastStore from '../../stores/toastStore'

const SellModal = (props) => {
    const { show, onHide, contact } = props
    const { addToast } = useToastStore()
    const { fetchContacts, createContact, updateContact, clearState, loading, error } = useContactStore()
    const [formData, setFormData] = useState({
        itemName: '',
        steamInventoryLink: '',
        tel: '',
        kind: 'offer', // Default to 'offer'
        memo: '',
    })

    const [errors, setErrors] = useState({})

    useEffect(() => {
        if (show) {
            if (contact) {
                setFormData({
                    itemName: contact.item_name || '',
                    steamInventoryLink: contact.steam_inventory_link || '',
                    tel: contact.tel || '',
                    kind: contact.kind || 'offer',
                    memo: contact.memo || '',
                })
            } else {
                setFormData({
                    itemName: '',
                    steamInventoryLink: '',
                    tel: '',
                    kind: 'offer',
                    memo: '',
                })
            }
            setErrors({})
        } else {
            setFormData({
                itemName: '',
                steamInventoryLink: '',
                tel: '',
                kind: 'offer',
                memo: '',
            })
            setErrors({})
        }
    }, [show, contact])

    const validate = () => {
        const newErrors = {}

        if (contact.status !== 'wait_confirm') {
            newErrors.common = 'Không thể cập nhật yêu cầu do yêu cầu đang được xử lý.'
        }

        if (!formData.itemName) newErrors.itemName = 'Tên vật phẩm không được để trống.'
        if (!formData.tel) newErrors.tel = 'Số điện thoại không được để trống.'
        else if (!/^\d+$/.test(formData.tel)) newErrors.tel = 'Số điện thoại phải là một số hợp lệ.'
        if (formData.steamInventoryLink && !/^https?:\/\/\S+$/.test(formData.steamInventoryLink))
            newErrors.steamInventoryLink = 'Link Steam Inventory phải là một đường link hợp lệ.'
        return newErrors
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }

    const handleSubmit = async () => {
        const validationErrors = validate()
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
            return
        }

        const contactData = {
            item_name: formData.itemName,
            steam_inventory_link: formData.steamInventoryLink,
            tel: formData.tel,
            kind: formData.kind,
            memo: formData.memo,
        }

        let result
        if (contact) {
            result = await updateContact(contact.id, contactData)
        } else {
            result = await createContact(contactData)
        }

        if (result.success) {
            addToast(contact ? 'Cập nhật yêu cầu thành công!' : 'Tạo yêu cầu thành công!', 'success')
            onHide()
            await fetchContacts()
        } else {
            addToast(result.message, 'danger')
        }
    }

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton></Modal.Header>

            <div className="modal-body space-y-20 pd-30">
                <h3>{contact ? 'Cập nhật yêu cầu' : 'Tạo yêu cầu'}</h3>
                <p>
                    Để bán cho chúng tôi vui lòng tạo yêu cầu phía dưới và cung cấp đầy đủ thông tin. Chúng tôi sẽ báo
                    giá sớm nhất có thể
                </p>
                <div className="hr"></div>

                <div className="form-group">
                    <h5 className="mb-15">Loại yêu cầu</h5>
                    <select id="kind" name="kind" value={formData.kind} required>
                        <option value="sell">Bán cho chúng tôi</option>
                    </select>
                </div>

                <div className="form-group">
                    <h5 className="mb-15">Tên vật phẩm</h5>
                    <input
                        type="text"
                        className="form-control"
                        id="itemName"
                        placeholder="Tên vật phẩm"
                        name="itemName"
                        value={formData.itemName}
                        onChange={handleInputChange}
                        required
                    />
                    {errors.itemName && <p className="text-danger">{errors.itemName}</p>}
                </div>

                <div className="form-group">
                    <h5 className="mb-15">Link Steam Inventory</h5>
                    <input
                        type="text"
                        className="form-control"
                        id="steamInventoryLink"
                        placeholder="Link Steam Inventory"
                        name="steamInventoryLink"
                        value={formData.steamInventoryLink}
                        onChange={handleInputChange}
                    />
                    {errors.steamInventoryLink && <p className="text-danger">{errors.steamInventoryLink}</p>}
                </div>

                <div className="form-group">
                    <h5 className="mb-15">Số điện thoại</h5>
                    <input
                        type="tel"
                        className="form-control"
                        id="tel"
                        placeholder="Số điện thoại"
                        name="tel"
                        value={formData.tel}
                        onChange={handleInputChange}
                        required
                    />
                    {errors.tel && <p className="text-danger">{errors.tel}</p>}
                </div>

                <div className="form-group">
                    <h5 className="mb-15">Ghi chú</h5>
                    <textarea
                        id="memo"
                        placeholder="Ghi chú"
                        name="memo"
                        value={formData.memo}
                        onChange={handleInputChange}
                    />
                </div>
                {errors.common && <p className="text-danger">{errors.common}</p>}

                <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? 'Loading...' : contact ? 'Cập nhật yêu cầu' : 'Tạo yêu cầu'}
                </button>
                {error && <p className="text-danger mt-2">{error}</p>}
            </div>
        </Modal>
    )
}

export default SellModal
